import * as Sentry from '@sentry/browser'
import { redirectToApp } from '@/services/utils/AppCommunication'
import type { ErrorResponse } from '@/plugins/2.axios'

export default () => {
  const route = useRoute()
  const { login: chromeExtensionLogin } = useChromeExtensionStore()
  const user = useUserStore()
  const snackbar = useSnackbar()
  const { isBrowserIOS, isBrowserAndroid } = useDeviceStore()
  const setError = (error: ErrorResponse | string, errors: Ref<Array<string>>) => {
    const IGNORABLE_ERRORS = [
      'popup_closed_by_user',
      'user_cancel',
      'access_denied',
      'opt_out_or_no_session'
    ]
    let errorMsg
    if (typeof error === 'string') {
      errorMsg = error
    } else if (error?.errorMsg) {
      errorMsg = error?.errorMsg
    } else if (error.isAxiosError && error.errors.length > 0) {
      errorMsg = error.errors[0]
    } else {
      errorMsg = 'An unknown error occurred'
    }
    if (IGNORABLE_ERRORS.includes(errorMsg)) { return }
    errors.value.push(errorMsg)
  }
  const finishAuthentication = async () => {
    try {
      const comesFromPlatform = route.query.comesFromPlatform
      if (comesFromPlatform) {
        return navigateTo({ path: '/app-login', query: { comesFromPlatform } })
      }
      await chromeExtensionLogin()
      if (route.query?.eid) {
        return navigateTo('/chrome-extension/')
      }
      await user.goToInboxOrHome()
    } catch (error) {
      Sentry.captureException(error)
      snackbar.error('An error occurred during authentication. Please try again.')
    }
  }
  const goToApp = (token?: string | null) => {
    try {
      const comesFromPlatform = route.query.comesFromPlatform
      if (comesFromPlatform) {
        redirectToApp(String(comesFromPlatform), token)
        return
      }
      if (isBrowserIOS()) {
        redirectToApp('ios', token)
        return
      }
      if (isBrowserAndroid()) {
        redirectToApp('android', token)
        return
      }
      snackbar.warning('We couldn`t detect your device. Please open the app again.')
    } catch (error) {
      Sentry.captureException(error)
      snackbar.error('An error occurred while trying to open the app.')
    }
  }
  return {
    setError,
    finishAuthentication,
    goToApp
  }
}
